import axios from 'axios';
import axiosInstance from '../axiosInstance';
import * as API from '../url';

export const getCountries = async () => {
  const res = await axios.get(API.COUNTRIES);
  return res.data;
};

export interface PublicCountry {
  uuid: string;
  name: string;
  isoCode: string;
}

// Our own backend's country list — use this instead of the third-party
// countriesnow.space API or the local country-list-with-dial-code-and-flag
// package wherever a country needs to be selected before org creation.
export const getPublicCountries = async (): Promise<PublicCountry[]> => {
  const res = await axiosInstance.get<PublicCountry[]>(API.API_URLS.PUBLIC_COUNTRIES);
  return res.data;
};

// Same list, but for an authenticated org-context country picker (e.g.
// Organization Settings) rather than the pre-auth signup flow that
// getPublicCountries serves.
export const getPeopleProfileCountries = async (): Promise<PublicCountry[]> => {
  const res = await axiosInstance.get<PublicCountry[]>(API.API_URLS.PEOPLE_PROFILE_COUNTRIES);
  return res.data;
};

export const COUNTRIES = 'https://countriesnow.space/api/v0.1/countries';

export const getCountriess = async (): Promise<
  { label: string; value: string }[]
> => {
  const res = await axios.get<{ data: { country: string }[] }>(COUNTRIES);

  return res.data.data.map((country) => ({
    label: country.country,
    value: country.country,
  }));
};
